"use client";
import NavBarSecond from "../components/NavBar/NavBarSecond";
import { PageBreadcrumbs } from "@/app/components/Breadcrumbs/PageBreadcrumbs";
import { resolveBreadcrumbs } from "@/lib/seo/breadcrumbs";
import Intro from "./components/hero";
import Lenis from "lenis";
import { useEffect } from "react";
import MasonryGrid from "./MansoryGrid/page";



export default function AllServicesPage() {
  useEffect(() => {
    const lenis = new Lenis();

    function raf(time: number) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  }, []);

  return (
    <div className="bg-white min-h-screen flex flex-col items-center">
      <header className="absolute top-0 w-full z-50">
        <NavBarSecond />
      </header>
      
      <section className="relative w-full bg-white py-0 flex items-center justify-center overflow-hidden">
        {/* Breadcrumbs positioned absolutely over the hero image */}
        <div className="absolute left-0 right-0 top-[92px] lg:top-[128px] z-20 px-6 sm:px-10 max-w-7xl mx-auto w-full">
          <PageBreadcrumbs items={resolveBreadcrumbs('/gallery')} variant="light" />
        </div>
        <Intro />
      </section>
      <div className="flex justify-center px-4 md:px-8 my-20 md:my-40">
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl xl:text-[2.2vw] text-center max-w-8xl leading-snug">
          Explore moments from therapy sessions, interactive activities, and
          progress milestones at The Speech Clinic. Our gallery showcases the
          engaging environment we create for children and adults through speech,
          occupational, and developmental therapies. From individual sessions to
          group interactions and specialized equipment in action, see how we
          bring communication and confidence to life.
        </p>
      </div>
      <MasonryGrid />

     
    </div>
  );
}
